import React from "react";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "../ui/sheet";
import { Badge } from "../ui/badge";
import { useTranslation } from "react-i18next";

interface OnboardingSheetProps {
  open: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  onClick?: () => void;
  isPending?: boolean;
  hasHeader?: boolean;
  blockClose?: boolean;
}

export default function OnboardingSheet({
  onClose,
  open,
  children,
  isPending,
  hasHeader = true,
  blockClose = false,
}: OnboardingSheetProps) {
  const { t } = useTranslation(["common"]);
  return (
    <Sheet
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen && blockClose) return;
        if (!nextOpen) onClose();
      }}
    >
      <SheetContent className="md:w-[504px] w-full h-[100vh] max-h-[100vh] overflow-y-auto p-0">
        {hasHeader && (
          <SheetHeader className="md:p-6 p-4 border-b border-b-colorBorder">
            <SheetTitle className="flex gap-2">
              {t("finish_your_board")}{" "}
              {isPending && (
                <Badge
                  style={{ backgroundColor: "rgba(250, 204, 21, 0.10)" }}
                  className="h-5 text-colorText gap-1.5 text-xs"
                >
                  <svg
                    width="6"
                    height="6"
                    viewBox="0 0 6 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="3" cy="3" r="3" fill="#FDE047" />
                  </svg>
                  {t("pending")}
                </Badge>
              )}
            </SheetTitle>
            <SheetDescription className="text-start">
              {t("finish_description")}
            </SheetDescription>
          </SheetHeader>
        )}
        {children}
      </SheetContent>
    </Sheet>
  );
}
